import { useGlobalForms } from '@lmt/unicorn-shared/app/components/global-forms/useGlobalForms';
import { useTabId } from '@lmt/unicorn-shared/app/components/keep-alive/TabContext';
import { useEffect } from 'react';
import { getCurrentlyOpenedTabId } from '../../features/navigation/operations';

export function useInsertKeyHandler(onInsertKeyDown: () => void) {
  const tabId = useTabId();
  const forms = useGlobalForms();
  useEffect(() => {
    const handleEvent = (event: KeyboardEvent) => {
      const currentlyOpenedTabId = getCurrentlyOpenedTabId();
      if (
        event.key !== 'Insert' ||
        event.altKey ||
        event.ctrlKey ||
        event.shiftKey ||
        event.metaKey ||
        currentlyOpenedTabId !== tabId
      )
        return;
      onInsertKeyDown();
    };

    document.addEventListener('keydown', handleEvent);
    return () => {
      document.removeEventListener('keydown', handleEvent);
    };
  }, [forms]);
}
